import RRC1 from "../../../assets/CampuLifeImages/RRC1.jpeg"
import ExtenStudClubGrievPage from '../../CampusSharedComponent/CampusDynamicPages/CampusExtenStudClubGrievDynamicPage/ExtenStudClubGrievPage';
import RRCbanner from "../../../assets/CampuLifeImages/RRCbanner.jpg"


const RRC = () => {

   const data = 
   { name:"rrc",
       hover:true,
    pagename: "RRC", 
    title: "RRC Activities",
    contentImg: RRCbanner,
    para:"The Red Ribbon Club (RRC) is an initiative by the National AIDS Control Organization (NACO) to educate youth on HIV/AIDS awareness, blood donation, and healthy living. It operates in schools and colleges to empower students with knowledge about preventive healthcare, stigma reduction, and responsible behaviour. RRC organizes awareness campaigns, blood donation drives, health check-up camps, and counselling sessions to promote a healthy and responsible lifestyle. By engaging students in these activities, RRC fosters leadership, social responsibility, and a proactive approach toward health issues.",
    paranext:"The club’s symbol, the red ribbon, represents solidarity and support for people living with HIV/AIDS. Through interactive sessions and peer education, RRC ensures that youth become advocates of change, spreading awareness in their communities.",
    fourhover:true,
    viewmore:true,
    viewless:true
  }
  
  const hoverContent =[
    {  img:RRC1, para1: "", para2: "" },
    {  img:RRC1, para1: "", para2: "" },
    {  img:RRC1, para1: "", para2: "" },
    {  img:RRC1, para1: "", para2: "" }
]
 
  return (
    <>
      <ExtenStudClubGrievPage data = {data} hoverContent = {hoverContent} />
    </>
  )
}

export default RRC